module.exports = __webpack_public_path__ + "static/media/emissor-b-4.2bd5af4b.png";